<section class="grid grid-2 buy">
  <div class="card buy-main">
    <div class="sold-out" *ngIf="soldOut">Sold out — disponible próximamente</div>

    <h1 class="buy-title">Reserva tu noche de misterio</h1>
    <p class="buy-lead">
      Llévate la edición en color de Murder Nights: cartas listas para jugar, con la intriga de los años 20 y reglamento en papel. Perfecto para cenas, quedadas o viajes de amigos.
    </p>

    <ul class="perk-list">
      <li *ngFor="let perk of perks">{{ perk }}</li>
    </ul>

    <div class="price-block">
      <div class="price-main">
        <span class="price-current">{{ basePrice | number: '1.2-2' }} EUR</span>
        <span class="price-tag">PVP</span>
      </div>
      <div class="price-detail">
        <div>Envío estimado: <strong>{{ shippingPrice | number:'1.2-2' }} EUR</strong></div>
        <div class="total">
          Total aprox.: <strong>{{ total | number: '1.2-2' }} EUR</strong></div>
      </div>
    </div>

    <div class="checkout">
      <button class="btn-primary btn-full btn-disabled" [disabled]="soldOut">
        <span class="strike">Comprar</span>
      </button>
      <p class="checkout-help">
        Disponible próximamente. Déjanos tu contacto para avisarte en cuanto se abra la siguiente tirada.
      </p>
      <a routerLink="/" class="back-link">Volver a la presentación</a>
    </div>
  </div>

  <div class="card buy-side">
    <h2>Dentro de la caja</h2>
    <ul class="content-list">
      <li>54 cartas en color (personajes, armas, lugares y objetivos)</li>
      <li>Reglamento en papel en español</li>
      <li>Reversos listos para barajar en mesa o en movimiento</li>
    </ul>

    <h3>Ambiente listo para jugar</h3>
    <p>
      Coloca las cartas sobre el mantel, atenúa la luz y deja sonar el jazz. Cada invitado tendrá un rol, un objetivo secreto y una excusa para sospechar de todos los demás.
    </p>
  </div>
</section>
